import api from './api';

async function signin(payload) {
  return api.post('/auth', payload);
}

export { signin };